import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import Icon from "../../icon";
import moment from "moment";
class DATEPICKER_OR extends Component {
    render() {
        const { label, subLabel, startDate, selectedDate, isDisable, dateFormat, placeholder, requiredField, minDate, maxDate, isRequired, customClass, dateOnly } = this.props;
        const { activeDateFormat } = this.props.adminSetting;

        var disableClass = isDisable ? "disabled" : "";       
       
        const CustomInput = React.forwardRef(({ value, onClick, onChange }, ref) => {
            let dateValue = (dateFormat === "MMMM yyyy" && value) ? new Date(value).toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : value;
            return (
                <input type="text" className="form-control" value={dateValue} placeholder={placeholder} onClick={onClick} onChange={onChange} ref={ref} />
            )          
    });

        const onChange = (date) => {
            if (moment(date, activeDateFormat.CSFormat, true).isValid()) {
                let dt = dateOnly && date ? new Date(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`) : date;
                selectedDate(dt);
            } else {
                // Handle invalid date input, e.g., show an error message
                console.error("Invalid date");
                selectedDate(null);
            }
        };


        const handleInput = (e)=>{
            const inputValue = e.target.value;
            if (inputValue === "") {
                selectedDate(null); // If input is empty, clear the date
            }
        }

        return (
            <div className={`date-picker-wrapper ${requiredField ? "required":""} ${disableClass}`}>
                <div className={`date-picker-container ${customClass}`}>
                    <div className="custom-input-label sub-label-container">
                        <div>{label}</div> 
                        <div>{subLabel}</div> 
                    </div>

                    <DatePicker selected={startDate} onChange={onChange} placeholderText={placeholder}
                        showMonthYearPicker={dateFormat === "MMMM yyyy" ? true : false}
                        dateFormat={dateFormat === "MMMM yyyy" ? "MMMM yyyy" : activeDateFormat.CSFormat}
                       
                        customInput={<CustomInput onChange={handleInput} />}
                        minDate={minDate}
                        maxDate={maxDate}
                     />
                    <Icon
                        customClassName="icon-left"
                        name="calendar-days"
                        size="25px"
                        containerClass="calendar-icon"
                    />
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        const { adminSetting } = state;

        return {
            adminSetting
        };
    }
)(DATEPICKER_OR)